import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  res => res,
  async err => {
    if (err.response?.status === 401 && !err.config._retry) {
      // Don't retry the /auth/me or /auth/refresh endpoints themselves
      const url = err.config.url || "";
      if (url.includes("/auth/me") || url.includes("/auth/refresh") || url.includes("/auth/login")) {
        return Promise.reject(err);
      }
      err.config._retry = true;
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`,
          {},
          { withCredentials: true }
        );
        return api(err.config);
      } catch {
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
